import React, { useState } from "react";
import "./index.css";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import { PhoneInfo } from "../../utils/getPhoneInfo";

export default function ArticleDetail(props) {
  const [url, setUrl] = useState("");
  const [ifIos, setifIos] = useState(1);

  useEffect(() => {
    if (!props.articleUrl) return;
    if (props.articleUrl.indexOf("?") > -1) {
      setUrl(`${props.articleUrl}&hasLogin=true&group_id=1`);
    } else {
      setUrl(`${props.articleUrl}?hasLogin=true&group_id=1`);
    }
  }, [props.articleUrl]);
  useEffect(() => {
    console.log("phoneInfo", PhoneInfo());
    setifIos(PhoneInfo());
  }, []);
  useEffect(() => {
    const aaa = document.querySelector("#root")
    aaa.style.display = "none"
    return (() => {
      aaa.style.display = "block"
    })
  }, []);

  const iframeRef = React.createRef();

  // const [messageData, setMessageData] = useState();

  if (!url) return null;

  function loadIframe() {
    // let lastHeight = 1800;
    // let intervalId = setInterval(() => {
    const iframe = iframeRef.current;
    console.log("hehehehehehehe", iframe.offsetHeight)
    iframe.style.height = iframe.offsetHeight + "px";
    // console.log("contentDocument", iframe.contentDocument)
    // console.log("contentWindow", iframe.contentWindow)
    // const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    // const body = iframeDocument.body

    // if (body.offsetHeight != lastHeight) {
    //   iframe.style.height = body.offsetHeight + "px";
    //   lastHeight = body.offsetHeight;
    // }
    // }, 1000)
  }

  return (
    <>
      {ReactDOM.createPortal(
        <div className="article-detail-layout">
          <span
            className="return-btn"
            onClick={(e) => {
              e.stopPropagation();
              props.close();
            }}
          >
            返回
          </span>
          <iframe className="article-detail-content" src={url} frameBorder="0" scrolling={ifIos === 1 ? "auto" : "no"} ref={iframeRef} ></iframe>
          {/* <IframeResizer src={url} log style={{ width: '1px', minWidth: '100%', height: "3600px"}} forwardRef={iframeRef}
            heightCalculationMethod="lowestElement"
            inPageLinks
            log
            onMessage={onMessage}
            onResized={onResized}
          /> */}
          {/* <iframe
            ref={iframeRef}
            className="article-detail-content"
            src={url}
            frameBorder="0"
            scrolling="no"
            id="iframe"
          // onLoad={loadIframe}
          ></iframe> */}
        </div>,
        document.querySelector("body")
      )}
    </>
  );
}
